<template>
  <div class="simulation">
    <div class="container marginHeader">
      <div class="row">
        <div class="col-12 col-xl-8 offset-xl-2">
          <div class="pdf-break-avoid">
            <h2 class="simulation__title">Résultats de votre simulation pour&nbsp;:</h2>
            <h3 class="simulation__subtitle">
              {{ prestationStore.name }}
              <span v-if="tarificationStore !== null">
                {{ displayDetailTarification }}
              </span>
            </h3>

            <div class="d-md-none" :class="isPDF ? 'd-none' : ''" v-if="resultatsSimulation.resultats.length === 3">
              <p>Choisissez les 2 régimes à comparer&nbsp;:</p>
              <div class="simulation__blocs mt-3 mb-3" role="group">
                <button type="button" class="simulation__bloc stdButton" :class="displayResultatsMobile[0] ? '--active --clickActive' : ''" @click="changeDisplayResultatsMobile(0)">Base</button>
                <button type="button" class="simulation__bloc stdButton" :class="displayResultatsMobile[1] ? '--active --clickActive' : ''" @click="changeDisplayResultatsMobile(1)">Option 1</button>
                <button type="button" class="simulation__bloc stdButton" :class="displayResultatsMobile[2] ? '--active --clickActive' : ''" @click="changeDisplayResultatsMobile(2)">Option 2</button>
              </div>
            </div>

            <div class="simulation__card">
              <div class="simulation__card__header d-flex justify-content-between align-items-center">
                <h4 class="simulation__card__header__title">Coût total du soin</h4>
                <div class="simulation__card__header__amount">{{ resultatsSimulation.montantDepense }}&nbsp;€</div>
              </div>
              <div class="simulation__card__parametres d-flex flex-column">
                <div class="simulation__card__parametre d-flex" v-if="optamVisibleStore">
                  <button class="switch" :class="OptamStore ? '' : 'switch--desactive'" @click="updateOptam">
                    <inline-svg src="/images/icones/icon_switch.svg" />
                  </button>
                  <div class="d-flex align-items-center">
                    <span @click="updateOptam">{{ OptamStore ? "avec OPTAM" : "sans OPTAM" }}</span>
                    <button type="button" class="simulation__modal__btn" data-bs-toggle="modal" data-bs-target="#optamModal">
                      <inline-svg src="/images/icones/icon_infobulle.svg" />
                    </button>
                  </div>
                </div>
                <div class="simulation__card__parametre d-flex" v-if="!isRegimeFromUrl" @click="updateTypeRegime">
                  <button class="switch" :class="typeRegimeStore === 'regime-general' ? 'switch--desactive' : ''">
                    <inline-svg src="/images/icones/icon_switch.svg" />
                  </button>
                  <div>{{ typeRegimeStore === "regime-general" ? "non" : "" }} affilié au régime Alsace - Moselle</div>
                </div>
              </div>
              <div class="simulation__resultats">
                <template v-for="(resultat, index) in resultatsSimulation.resultats" :key="index">
                  <div class="simulation__resultat d-md-block" :class="displayResultatsMobile[index] ? 'simulation__resultat--xsVisible' : 'd-none'">
                    <h5 class="simulation__resultat__title">{{ resultat.optionName }}</h5>
                    <div class="simulation__resultat__item">
                      <div class="d-flex justify-content-between">
                        <h6 class="simulation__resultat__item__title">Sécurité Sociale</h6>
                        <div class="simulation__resultat__item__amount">{{ formatNumber(resultat.remboursementSecuriteSociale) }}&nbsp;€</div>
                      </div>
                      <div class="simulation__resultat__item__chart">
                        <div class="simulation__resultat__item__chart--colored --secu" :style="'width:' + pourcent(resultat.remboursementSecuriteSociale, resultatsSimulation.montantDepense) + '%'"></div>
                      </div>
                    </div>
                    <div class="simulation__resultat__item --strong">
                      <div class="d-flex justify-content-between">
                        <h6 class="simulation__resultat__item__title">Vivinter</h6>
                        <div class="simulation__resultat__item__amount --big">{{ formatNumber(resultat.remboursementMutuelle) }}&nbsp;€</div>
                      </div>
                      <div class="simulation__resultat__item__chart">
                        <div class="simulation__resultat__item__chart--colored --vivinter" :style="'width:' + pourcent(resultat.remboursementMutuelle, resultatsSimulation.montantDepense) + '%'"></div>
                      </div>
                      <div v-if="resultat.sousPrestations && resultat.sousPrestations.length" class="simulation__resultat__subdetails">
                        <div v-for="(sousPrestation, sousPrestationIndex) in resultat.sousPrestations" :key="`${index}-${sousPrestationIndex}`" class="simulation__resultat__subdetails__line d-flex justify-content-between">
                          <span class="simulation__resultat__subdetails__label">{{ getSousPrestationLabel(sousPrestation) }}&nbsp;:</span>
                          <span class="simulation__resultat__subdetails__amount">{{ formatNumber(sousPrestation.remboursementMutuelle) }}&nbsp;€</span>
                        </div>
                      </div>
                    </div>
                    <div class="simulation__resultat__item --strong">
                      <div class="d-flex justify-content-between">
                        <h6 class="simulation__resultat__item__title">À votre charge</h6>
                        <div class="simulation__resultat__item__amount --big">{{ formatNumber(resultat.resteACharge) }}€</div>
                      </div>
                      <div v-if="resultat.tauxCouverture !== 100" class="simulation__resultat__item__chart">
                        <div class="simulation__resultat__item__chart--colored" :style="'width:' + (100 - resultat.tauxCouverture) + '%'"></div>
                      </div>
                      <div v-else class="badge">
                        Totalement remboursé
                        <inline-svg src="/images/icones/icon_check.svg" />
                      </div>
                    </div>
                    <template
                      v-if="
                        (objectHelper.isDefined(resultat.plafondSecuriteSocialeDepasse) && resultat.plafondSecuriteSocialeDepasse == true) ||
                        (objectHelper.isDefined(resultat.plafondComplementaireDepasse) && resultat.plafondComplementaireDepasse == true)
                      ">
                      <div class="option-line">
                        <span class="option-label">Plafond dépassé !</span>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <!-- Info Bloc -->
          <div class="infoBloc infoBloc--reverse mt-4 pdf-break-avoid" v-if="displayInfoBlocResteCharge">
            <div class="infoBloc__icon">
              <inline-svg src="/images/icones/icon_information.svg" />
            </div>
            <p class="infoBloc__text">Le reste à charge exclut la participation forfaitaire de la Sécurité Sociale.</p>
          </div>
          <div class="infoBloc infoBloc--reverse mt-4" v-if="displayInfoBlocOrthodontiste">
            <div class="infoBloc__icon">
              <inline-svg src="/images/icones/icon_information.svg" />
            </div>
            <p class="infoBloc__text">Le remboursement est pour un semestre de traitement. La sécurité sociale rembourse jusqu'à 6 semestres de à hauteur de 193,50€/semestre. Au delà le coût des traitements supplémentaires sera à votre charge.</p>
          </div>
          <div class="infoBloc infoBloc--reverse mt-4" v-if="displayInfoBlocImplant">
            <div class="infoBloc__icon">
              <inline-svg src="/images/icones/icon_information.svg" />
            </div>
            <p class="infoBloc__text">Ne tient pas compte de vos de vos éventuelles consommations au cours de l'année en cours.</p>
          </div>
          <!-- ACTIONS -->
          <div class="simulation__actionBtn pdfHidden">
            <button class="actionBtn actionBtn--noIcon" @click="resetSimulation">Faire une nouvelle simulation</button>
            <button class="actionBtn actionBtn--empty actionBtn--iconBefore" @click="downloadSimulation">
              <inline-svg src="/images/icones/icon_download.svg" />
              Télécharger la simulation
            </button>
          </div>
          <!-- FOOTER -->
          <div class="simulation__footer pdf-break-avoid">
            <div class="simulation__footer__estimation">
              <h2 class="simulation__footer__estimation__title">Besoin d'une estimation plus précise ?</h2>
              <div class="row">
                <div class="col-12 col-lg-9">
                  <p class="simulation__footer__estimation__text">
                    <a
                      :href="'/documents/' + (clientCode === 'fedex_rt' ? 'FEDEX FRT - Résumé de garanties Santé 2026.pdf' : 'FEDEX EXPRESS - Résumé de garanties Santé 2026.pdf')"
                      class="simulation__footer__estimation__link"
                      target="_blank"
                      rel="noopener noreferrer">
                      Consultez le résumé des garanties.
                    </a>
                  </p>
                  <p class="simulation__footer__estimation__text">Rendez-vous sur votre Espace Assuré pour envoyer un devis et obtenir une estimation personnalisée de vos remboursements.</p>
                </div>
              </div>
            </div>
            <p class="simulation__footer__text">Les résultats sont exprimés hors réseau de soins. En choisissant un professionnel associé au réseau de soin, vous pourrez profiter d'un meilleur remboursement.</p>
            <p class="simulation__footer__text">Les résultats sont exprimés pour un professionnel de santé conventionné de secteur 2. Cela signifie qu'un tarif maîtrisé est pratiqué mais qu'une partie du prix peut rester à charge de l'assuré.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade simulation__modal" id="optamModal" tabindex="-1" aria-labelledby="optamModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="simulation__modal__header">
            <div class="simulation__modal__header__icon">
              <inline-svg src="/images/icones/icon_infobulle.svg" />
            </div>
            <h2 class="simulation__modal__header__title" id="optamModalLabel">Qu'est ce que l'OPTAM ?</h2>
          </div>
          <p class="simulation__modal__text">
            En consultant un médecin sans l'Option de Pratique Tarifaires Maitrisés (sans OPTAM), vous pourrez avoir un dépassement d'honoraires plus important, un remboursement plus faible et donc un reste à charge plus élevé.
          </p>
          <p class="simulation__modal__text">En consultant un médecin avec l'Option de Pratique Tarifaires Maitrisés (avec OPTAM), vous profitez de dépassements d'honoraires limités, d'un meilleur remboursement et d'un reste à charge réduit.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { buildLabel, mapEtatOptam, mapTypePrestation, mapTypeSoin, mapTypeTarification, pushSimulationEvent } from "@/helpers/matomo";
  import { normalizeRouteContext } from "@/helpers/entrySource";
  import { objectHelper } from "@/helpers";
  import useVuelidate from "@vuelidate/core";
  import { helpers } from "@vuelidate/validators";

  export default {
    name: "SimulationPage",
    emits: ["runSimulation", "resetSimulation", "downloadSimulation"],
    components: {},
    props: {
      resultatsSimulation: Object,
      isPDF: Boolean,
    },
    setup() {
      return { v$: useVuelidate() };
    },
    data() {
      const routeContext = normalizeRouteContext(this.$route.params);

      return {
        objectHelper: objectHelper,

        // Données de l'URL
        clientCode: this.$route.params.clientCode,
        sourceEntree: routeContext.sourceEntree,
        typeRegime: routeContext.typeRegime,
        isRegimeFromUrl: routeContext.isRegimeFromUrl,
        displayResultatsMobile: [true, true, false],
      };
    },
    computed: {
      prestationStore() {
        return this.$store.getters["dataSimulateurStore/prestation"];
      },
      tarificationStore() {
        return this.$store.getters["dataSimulateurStore/tarification"];
      },
      typeRegimeStore: {
        get() {
          return this.$store.getters["dataSimulateurStore/typeRegime"];
        },
        set(value) {
          this.$store.dispatch("dataSimulateurStore/updateTypeRegime", value);
        },
      },
      OptamStore: {
        get() {
          return this.$store.getters["dataSimulateurStore/isOptam"];
        },
        set(value) {
          this.$store.dispatch("dataSimulateurStore/updateOptam", value);
        },
      },
      optamVisibleStore() {
        return this.$store.getters["dataSimulateurStore/isOptamVisible"];
      },
      displayDetailTarification() {
        switch (this.tarificationStore) {
          case "CentPourCent":
            return "avec le dispositif 100% Santé";
          case "TarifMaitrise":
            return "avec le tarif maitrisé";
        }
        return "";
      },

      displayInfoBlocResteCharge() {
        return this.resultatsSimulation.resultats.some((item) => item.tauxCouverture !== 100);
      },

      displayInfoBlocOrthodontiste() {
        return this.prestationStore?.key === "OrthodontieNonRembourseeParSecuriteSociale" || this.prestationStore?.key === "OrthodontieRembourseeParSecuriteSociale";
      },
    },
    async mounted() {
      console.debug("Component Simulation is mounted!");
    },
    watch: {
      resultatsSimulation: {
        immediate: true,
        deep: true,
        handler() {
          this.trackAffichageResultat();
        },
      },
    },
    methods: {
      getTrackingContext(includeOptam = false) {
        const typeSoin = mapTypeSoin(this.$store.getters["dataSimulateurStore/typeDepense"]);
        const typePrestation = mapTypePrestation(this.prestationStore);
        const typeTarification = mapTypeTarification(this.tarificationStore);
        const etatOptam = mapEtatOptam(this.OptamStore);

        return {
          etatOptam,
          label: buildLabel({
            typeSoin,
            typePrestation,
            typeTarification,
            etatOptam,
            includeOptam,
          }),
        };
      },

      trackAffichageResultat() {
        if (!this.resultatsSimulation || !Array.isArray(this.resultatsSimulation.resultats)) {
          return;
        }

        const context = this.getTrackingContext(true);

        this.resultatsSimulation.resultats.forEach((resultat, index) => {
          const montantRembourse = Number(resultat?.remboursementMutuelle) || 0;

          pushSimulationEvent({
            event: "affichage_resultat",
            action: "affichage_resultat",
            label: context.label,
            payload: {
              montant_rembourse: montantRembourse,
              etat_optam: context.etatOptam,
              option_name: resultat?.optionName || `option_${index + 1}`,
            },
            value: montantRembourse,
          });
        });
      },

      updateOptam() {
        const nextOptamState = !this.OptamStore;
        const etatOptam = mapEtatOptam(nextOptamState);

        pushSimulationEvent({
          event: "toggle_optam",
          action: "toggle_optam",
          label: `optam_${etatOptam}`,
          payload: {
            etat_optam: etatOptam,
          },
        });

        this.OptamStore = nextOptamState;
        this.$emit("runSimulation");
      },

      updateTypeRegime() {
        this.typeRegimeStore = this.typeRegimeStore === "regime-general" ? "alsace-moselle" : "regime-general";
        this.$emit("runSimulation");
      },

      resetSimulation() {
        this.$emit("resetSimulation");
      },

      downloadSimulation() {
        this.$emit("downloadSimulation");
      },

      pourcent(part, total) {
        const percent = (part / total) * 100;
        return percent.toFixed(2);
      },

      formatNumber(value) {
        return Number.isInteger(value)
          ? value
          : value.toLocaleString("fr-FR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
      },

      getSousPrestationLabel(sousPrestation) {
        if (sousPrestation.libelle && sousPrestation.libelle.length) {
          return sousPrestation.libelle;
        }

        return sousPrestation.code || "Sous-prestation";
      },

      //FONCTION pour la vue Mobile
      changeDisplayResultatsMobile(index) {
        var arr = [...this.displayResultatsMobile];
        const wasTrue = arr[index];

        //Si l'élément clic est initialement à true, on le passe à false et on passe tous les autres à true
        if (wasTrue) {
          arr = arr.map((_, i) => (i === index ? false : true));
        }
        //Si l'élément clic est initialement à false
        else {
          arr[index] = !arr[index]; //on toogle son état

          // Si tous les éléments du tableau sont à true :
          // - permet d'avoir tjs que 2 choix de selectionné
          // - permet de faire un switch logique entre Option 1 et Option 2 (index 1 et 2)
          // - permet d'avoir une condition initial Base + Option 1 si on venait à clic sur l'option Base qui était initialement à false
          if (arr.every((val) => val === true)) {
            switch (index) {
              case 0:
              case 1:
                arr[2] = false;
                break;
              case 2:
                arr[1] = false;
                break;
            }
          } else if (index === 0) {
            arr[2] = false;
          }
        }
        this.displayResultatsMobile = arr;
      },
    },
  };
</script>
